export default __webpack_public_path__ + "static/iphone12-8f1d4b0e8e9602038da522bf2b4df131.png";